// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.SignUp.View'
,	[
	'c3_shoppingextensions_signup.tpl'
	,  'Profile.Model'
	//,	'NXTurn.ShoppingExtensions.LoginRegister.SS2Model'
	,	'Backbone'
	,   'Backbone.FormView'
	,   'Backbone.CompositeView'
	,    'Tracker'
	//,	'SC.Configuration'
    ,   'Session'	
    ,   'C3.ShoppingExtensions.SignUp.Model'
    ,   'Utils'
    ,   'LiveOrder.Model'
    ,   'GlobalViews.Message.View'
    ,   'Loggers'
   ,   'GoogleTagManager'
   ,   'C3.ShoppingExtensions.SignUp.CustomFields.View'
    ]
, function (
	c3_shoppingextensions_signup_tpl
	,   ProfileModel
	//,	LoginRegisterSS2Model	
	,	Backbone
	,   BackboneFormView
	,   BackboneCompositeView
	,   Tracker
	//,   Configuration
	,   Session
	,   SignUpModel
	,   Utils
	,   LiveOrderModel
	,   GlobalViewsMessageView
    ,   Loggers
    ,   GoogleTagManager
    ,   SignUpCustomFields
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_signup_tpl

	, attributes: {
        id: 'register'
    }	

    ,  events: {
        'submit form': 'submitForm'
    }

    ,  bindings: {
        '[name="firstname"]': 'firstname',
        '[name="lastname"]': 'lastname',
        /*'[name="company"]': 'company',
        '[name="country"]': 'country',
        '[name="ima"]': 'ima',*/
        '[name="email"]': 'email',
        '[name="custentity13"]': 'custentity13'
    }

	,	initialize: function (options) {
		this.options = options;
        this.application = options.application;
        //this.parentView = options.parentView;
        //console.log(this)
        //this.countries = this.application.configuration.get('siteSettings.countries', []);

        this.model = options.model || new SignUpModel();
        // on save we redirect the user out of the registration page
        // as we know there hasn't been an error
        this.model.on('save', _.bind(this.redirect, this));

        BackboneFormView.add(this);
			
		},


    childViews: {
         'SignUpForm.CustomFields': function() {
            return new SignUpCustomFields({
                application: this.application,
                LoginRegisterPage : this
            });
        }
    },     

    getBreadcrumbPages: function() {
        return { href: '/signup-form', text: Utils.translate('Sign Up') };
    },   

	submitForm: function(e, model, props) {
        e.preventDefault();

        //console.log(Loggers)
        //const loggers = Loggers.getLogger();
       // const actionId = loggers.start('Customer Registration');

        const self = this;
        const data = (jQuery(e.target).closest('form')).serializeObject();
       // console.log(data)
        return this.cancelableTrigger('before:LoginRegister.register', data).then(function() {
            const promise = self.saveForm(e, model, props);

           /* if (promise) {
                promise.done(() => {
                    loggers.end(actionId, {
                        operationIds: self.model.getOperationIds(),
                        status: 'success'
                    });
                });
            }*/
        });
    },
    /*beforeShowContent: function beforeShowContent() {
        const promise = jQuery.Deferred();
        const profileModel = ProfileModel.getInstance();

        if (profileModel.get('isLoggedIn') === 'T' && profileModel.get('isGuest') === 'F') {
            Backbone.history.navigate('', { trigger: true });

            promise.reject();
        } else {
            promise.resolve();
        }

        return promise;
    },*/

    // @method trackEvent tracks the 'create-account' event using the global Tracker instance
    // @param {Function} callback
    /*trackEvent: function(callback) {
        Tracker.getInstance().trackRegister({
            action: 'Checkout - User Interaction',
            category: 'Register',
            callback: callback
        });
    },*/

    // @method redirect redirects the user after successful account registration taking into account redirect (origin and origin_hash) parameters.
    // @param {Object} response the http response data object result of calling the account-register service.
    redirect: function(_context, response) {
        const self = this;

        console.log(response)
        if(response.user)
        {
            $('.login-register-register-form')[0].reset();
            $('.signup-success').css('display','block');
            $(".signup-success").fadeOut(5000);
        }
    }

		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{


			return {
			
            };
		}
	});
});
